import { PrintMenu } from '../print-menu';
import { Type } from '@angular/core';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import { BandedRowMode } from '../../enum/shared/banded-row-mode.enum';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { BandedRowColorContrast } from '../../enum/shared/banded-row-color-contrast.enum';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { PrintHeaderLayoutType } from '../../enum/shared/print-header-layout-type.enum';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { SectionColumnType } from '../../enum/shared/section-column-type';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class TrueNorthPrintMenu extends PrintMenu {
  getThemeClass(): string {
    return 'true-north-print-theme';
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.Montserrat.Medium_500,
      FONT.Montserrat.SemiBold_600,
      FONT.Montserrat.Bold_700,
      FONT.Montserrat.ExtraBold_800
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/buf2vss.css';
  }

  getPageBottomMargin(): string {
    return '0.25in';
  }

  getPageLeftMargin(): string {
    return '0.25in';
  }

  getPageRightMargin(): string {
    return '0.25in';
  }

  getPageTopMargin(): string {
    return '0.25in';
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    return MenuHeaderTitleImageComponent;
  }

  getPrintHeaderLayoutType(): PrintHeaderLayoutType {
    return this.menuOptions?.printHeaderLayout || PrintHeaderLayoutType.FirstPage;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getProductWrapperClass(odd: boolean) {
    return odd ? 'product-row-overlay' : '';
  }

  override getColumnOrdering(): Map<SectionColumnType, number> {
    return new Map<SectionColumnType, number>([
      [SectionColumnProductInfoType.ProductTitle, 0],
      [SectionColumnProductInfoType.Strain, 1],
      [SectionColumnProductInfoType.StrainType, 2],
      [SectionColumnProductInfoType.Brand, 3],
      [SectionColumnProductInfoType.Badge, 4],
      ...SectionColumnViewModel.getDefaultAdditionalDetailsColumnOrder(5),
      SectionColumnViewModel.getDefaultProductTagGroupColumnOrdering(6),
      ...SectionColumnViewModel.getDefaultCannabinoidColumnOrdering(7),
      ...SectionColumnViewModel.getDefaultTerpeneColumnOrdering(8),
      [SectionColumnProductInfoType.QuantityAndSize, 9],
      [SectionColumnProductInfoType.Quantity, 10],
      [SectionColumnProductInfoType.Size, 11],
      [SectionColumnProductInfoType.VariantType, 12],
      [SectionColumnProductInfoType.Stock, 13],
      [SectionColumnProductInfoType.GradingResults, 14],
      [SectionColumnProductInfoType.VariantPrice, 15],
      [SectionColumnProductInfoType.VariantSecondaryPrice, 16]
    ]);
  }

  bandedRowMode(): BandedRowMode {
    return BandedRowMode.Even;
  }

  bandedRowColor(rowViewModel: SectionRowViewModel, odd: boolean): string {
    if (this.currentRowIsBanded(odd)) {
      const opacity = '0.03';
      return `rgba(0, 0, 0, ${opacity})`;
    } else {
      return null;
    }
  }

  bandedRowColorContrast(): BandedRowColorContrast {
    return BandedRowColorContrast.Lighten;
  }

  getShowProductSubtitle(): boolean {
    return false;
  }

  getSectionHeaderUnderlined(): boolean {
    return false;
  }

  getTitleSectionTopMargin(): string {
    return '1rem';
  }

  getTitleSectionBottomMargin(): string {
    return '0';
  }
}
